import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  CircularProgress,
  DialogActions,
  DialogContent,
  Grid,
  InputAdornment,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import axios from "axios";
import React, { useEffect, useState, useContext } from "react";
import {
  CALL_STATUS,
  CALL_TYPE,
  CATEGORY,
  CLOSED_SUB_CATEGORY,
  COLD_SUB_CATEGORY,
  CREATE_LEAD_API,
  ENQUIRY_TYPE,
  GET_BRANCH_AND_REGION_LIST_BY_AGENT,
  GET_CATEGORY_AND_SUBCATEGORY_LIST,
  GET_DETAILS_BY_MOBILE_NUMBER,
  HOT_SUB_CATEGORY,
  PENDING_SUB_CATEGORY,
  REGION_TO_BDM,
  STATE_API,
  STATE_TO_REGION,
  TITLE,
  WARM_SUB_CATEGORY,
} from "../../constants";
import leadFormStyles from "../Leads Page/leadFormStyles.module.css";
import {
  DatePicker,
  DateTimePicker,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";

function AddLeadForm({
  setOpen,
  setOpenSnackbar,
  setSeverity,
  setMessage,
  place,
  ParticipantMobNo,
  leadNumber,
  afterLeadCreatedCallback,
}) {
  const empDetails = JSON.parse(localStorage.getItem("userData"));

  const navigate = useNavigate();

  //Other
  const [bdmID, setBdmId] = useState("");
  const [regionName, setRegionName] = useState("");
  const [isPresent, setIsPresent] = useState(false);
  const [mobileLoading, setMobileLoading] = useState(false);
  const [isMandatory, setIsMandatory] = useState(true);
  const [regionNameList, setRegionNameList] = useState([]);
  const [locationList, setLocationList] = useState([]);
  const [filteredLeadOwners, setFilteredLeadOwners] = useState([]);
  const [filteredProject, setFilteredProject] = useState([]);
  const [bdmList, setBdmList] = useState([]);
  const [projectList, setProjectList] = useState([]);
  const [isOtherLocation, setIsOtherLocation] = useState(true);
  const [pincodeLoading, setPincodeLoading] = useState(false); // State for loader
  const [categoryLoading, setCategoryLoading] = useState(false);
    const [categoryList, setCategoryList] = useState([]);
    const [branchLoading, setBranchLoading] = useState(false);
    const [branchList, setBranchList] = useState([]);

  //Feilds
  const [project, setProject] = useState("");
  const [callType, setCallType] = useState("");
  const [title, setTitle] = useState("");
  const [siteLocationAddress, setSiteLocationAddress] = useState("");
  const [leadTransferDate, setLeadTransferDate] = useState(undefined);
  const [leadOwner, setLeadOwner] = useState("");
  const [agentRemark, setAgentRemark] = useState("");
  const [followUpDate, setFollowUpDate] = useState(undefined);
  const [closureMonth, setClosureMonth] = useState(null);
  const [callStatus, setCallStatus] = useState("");
  const [firstName, setFirstName] = useState("");
  const [middleName, setMiddleName] = useState("");
  const [lastName, setLastName] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [whatsappNumber, setWhatsappNumber] = useState("");
  const [alternateNumber, setAlternateNumber] = useState("");
  const [mailId, setMailId] = useState("");
  const [pincode, setPincode] = useState("");
  const [state, setState] = useState("");
  const [region, setRegion] = useState("");
  const [selectedCategory, setSelectedCategory] = useState({
        id: null,
        name: "",
      });
      const [selectedSubCategory, setSelectedSubCategory] = useState({
        id: null,
        name: "",
      });
  const [leadSource, setLeadSource] = useState("");
  const [enquiryType, setEnquiryType] = useState("");
  const [location, setLocation] = useState("");
  const [branchName, setBranchName] = useState('');
  const [branchId, setBranchId] = useState("");

  //Validation Error
  const [agentRemarkError, setAgentRemarkError] = useState("");
  const [projectError, setProjectError] = useState("");
  const [firstNameError, setFirstNameError] = useState("");
  const [middleNameError, setMiddleNameError] = useState("");
  const [lastNameError, setLastNameError] = useState("");
  const [mobileNumberError, setMobileNumberError] = useState("");
  const [whatsappNumberError, setWhatsappNumberError] = useState("");
  const [alternateNumberError, setAlternateNumberError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [pincodeError, setPincodeError] = useState("");
  const [stateError, setStateError] = useState("");
  const [regionError, setRegionError] = useState("");
  const [categoryError, setCategoryError] = useState("");
  const [subCategoryError, setSubCategoryError] = useState("");
  const [leadSourceError, setLeadSourceError] = useState("");
  const [leadOwnerError, setLeadOwnerError] = useState("");
  const [enquiryTypeError, setEnquiryTypeError] = useState("");
  const [callStatusError, setcCallStatusError] = useState("");
  const [callTypeError, setCallTypeError] = useState("");
  const [locationError, setLocationError] = useState("");
  const [followUpDateError, setFollowUpDateError] = useState("");
  const [titleError, setTitleError] = useState("");
  const [closureMonthError, setClosureMonthError] = useState("");
  const [branchNameError, setBranchNameError] = useState("");

  useEffect(() => {
    handleGetCategoryAndSubCategory();
    handleGetBranchandRegionByBDM();
  }, []);


  const handleGetCategoryAndSubCategory = () => {
  setCategoryLoading(true); // Start loading
  axios
    .get(`${GET_CATEGORY_AND_SUBCATEGORY_LIST}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("authToken")}`,
      },
    })
    .then((response) => {
      setCategoryList(response.data);
    })
    .catch((error) => {
      if (error.response && error.response.status === 401) {
        handleLogout();
      } else {
        setCategoryError("Failed to fetch data. Please try again.");
      }
    })
    .finally(() => {
      setCategoryLoading(false); // Stop loading
    });
};



    const handleGetBranchandRegionByBDM = () => {
    setBranchLoading(true); // Start loading
    axios
      .get(
        `${GET_BRANCH_AND_REGION_LIST_BY_AGENT}/${localStorage.getItem(
          "username"
        )}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      )
      .then((response) => {
        const { branchList } = response.data;
        setBranchList(branchList);
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
        handleLogout();
      } else {
        setBranchNameError("Failed to fetch data. Please try again.");
      }
      })
      .finally(() => {
        setBranchLoading(false); // Stop loading
      });
  };

  const handleLogout = () => {
    localStorage.clear();
    Cookies.remove("authToken", { path: "/" });
    navigate("/");
    navigate(0);
  };

  const handleIsMandatory = (value) => {
    if (value === "Failed" || value === "pending") {
      setIsMandatory(false);
    } else {
      setIsMandatory(true);
    }
  };

  useEffect(() => {
    if (place === "Group") {
      setMobileNumber(ParticipantMobNo);
    }
  }, [place]);

  useEffect(() => {
    if (leadNumber) {
      setMobileNumber(leadNumber);
    }
  }, [leadNumber]);

  const handleMobileNumberChange = (e) => {
    const value = e.target.value;
    // Validate for empty value
    if (value.trim() === "") {
      setMobileNumber("");
      handleReset();
      setMobileNumberError("Mobile Number is required");
    } else {
      // Validate for numeric characters only and length
      if (/^\d{0,10}$/.test(value)) {
        setMobileNumber(value);
        setMobileNumberError("");
        fetchDataByMobileNo(value);
      } else {
        setMobileNumberError("Mobile Number should be 10 digits");
      }
    }
  };

  const fetchDataByMobileNo = (mobNo) => {
    if (mobNo.length === 10) {
      setMobileLoading(true); // Start loading
      axios
        .get(`${GET_DETAILS_BY_MOBILE_NUMBER}/${mobNo}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        })
        .then((response) => {
          const { lead } = response.data;

          if (!lead || Object.keys(lead).length === 0) {
            // Handle case where lead is empty or null
            setIsPresent(false);
            // setSeverity("warning");
            // setMessage("No lead data available for the given mobile number");
            // setOpenSnackbar(true);
            handleReset();
            return; // Exit early
          }

          if (
            response.data.message ===
            "Lead not found for the given mobile number"
          ) {
            setIsPresent(false);
            setSeverity("success");
            setMessage("Lead not found for the given mobile number");
            setOpenSnackbar(true);
            handleReset();
          } else {
            // Populate the state variables with the fetched lead data
            setIsPresent(true);
            setFetchedLeadData(lead, response.data.message);
          }
        })
        .catch((error) => {
          setMobileNumberError("Failed to fetch data. Please try again.");
        })
        .finally(() => {
          setMobileLoading(false); // Stop loading
        });
    }
  };

  const fetchStateAndRegionByPincode = (value) => {
      setPincodeLoading(true);
      axios
        .get(`${STATE_API}/${value}`,{
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        })
        .then((response) => {
          console.log(response);
  
          setState(response?.data?.stateName);
  
          fetchRegionFromState(response?.data?.stateName);
          setStateError("");
  
          //Map region so can be used for region feild
          const namesArray = response.data.places.map((item) => ({
            names: item.placeName,
          }));
  
          setLocationList(namesArray);
        })
        .catch((error) => {
          console.error("Error fetching pincode data:", error);
          setMessage(error.response?.data?.error || "Failed to fetch data");
          setSeverity("error");
          setOpenSnackbar(true);
          setStateError("Failed to fetch state. Please try again.");
        })
        .finally(() => {
          setPincodeLoading(false); // Stop loading
        });
    };

  // const fetchStateAndRegionByPincode = (value) => {
  //   setPincodeLoading(true);
  //   axios
  //     .get(`https://api.postalpincode.in/pincode/${value}`)
  //     .then((response) => {
  //       console.log(response.data[0].PostOffice);
  //       if (response.data[0].PostOffice == null) {
  //         setSeverity("error");
  //         setMessage(response.data[0].Message);
  //         setOpenSnackbar(true);
  //         return;
  //       }
  //       setState(
  //         response.data[0].PostOffice[0].State === "Chattisgarh"
  //           ? "Chhattisgarh"
  //           : response.data[0].PostOffice[0].State
  //       );

  //       fetchRegionFromState(
  //         response.data[0].PostOffice[0].State === "Chattisgarh"
  //           ? "Chhattisgarh"
  //           : response.data[0].PostOffice[0].State
  //       );
  //       setStateError("");

  //       //Map region so can be used for region feild
  //       const namesArray = response.data[0].PostOffice.map((item) => ({
  //         names: item.Name,
  //       }));

  //       setLocationList(namesArray);
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching pincode data:", error);
  //       setStateError("Failed to fetch state. Please try again.");
  //     })
  //     .finally(() => {
  //       setPincodeLoading(false); // Stop loading
  //     });
  // };

  const fetchRegionFromState = (state_name) => {
    axios
      .get(`${STATE_TO_REGION}/${state_name}`)
      .then((response) => {
        setRegionNameList(response.data);
        if (response.data.length === 1) {
          fetchLeadOwnerfromRegion(response.data[0].RegionId);
        }
      })
      .catch((error) => {
        console.error("Error fetching pincode data:", error);
      });
  };

  const fetchLeadOwnerfromRegion = (regionName) => {
    axios
      .get(`${REGION_TO_BDM}/${regionName}`,{
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        })
      .then((response) => {
        const uniqueBdmList = Array.from(
          new Set(
            response.data.data.map((employee) =>
              JSON.stringify({
                EmployeeId: employee.EmployeeId,
                EmployeeName: employee.EmployeeName,
                leadSources: employee.leadSources || [],
                project: employee.Project,
              })
            )
          )
        ).map(JSON.parse);

        // Always update BDM list
        setBdmList(uniqueBdmList);

        if (uniqueBdmList.length === 1) {
          const [singleBDM] = uniqueBdmList;
          setBdmId(singleBDM.EmployeeId);
          setLeadOwner(singleBDM.EmployeeName); // store ID not name
          setProject(singleBDM.project);
        } else {
          // Reset fields if not exactly one
          setBdmId("");
          setLeadOwner("");
          setProject("");
        }

        // Unique projects
        const uniqueProjects = Array.from(
          new Set(response.data.data.map((employee) => employee.Project))
        ).map((project) => ({ label: project }));

        setProjectList(uniqueProjects);
      })
      .catch((error) => {
        console.error("Error fetching BDM data:", error);
        setSeverity("warning");
        setMessage(error.response?.data?.message || "Failed to fetch data");
        setOpenSnackbar(true);
        setLeadOwner("");
        setBdmList([]);
        setProjectList([]);
      });
  };

  // When Lead Owner is selected
  const handleProjectChange = (selectedProject) => {
    // Filter BDM list based on the selected lead source
    const filteredProject = bdmList.filter(
      (bdm) => bdm.EmployeeId === selectedProject
    );

    // Extract unique lead owners
    const uniqueProject = Array.from(
      new Set(filteredProject.map((owner) => owner.project))
    );

    setFilteredProject(uniqueProject);
  };

  const setFetchedLeadData = (lead, message) => {
    setSeverity("success");
    setMessage(message);
    setOpenSnackbar(true);

    setFilteredProject([lead.Project] || []);
    setCallType(lead.call_type || "");
    setTitle(lead.CustomerName?.split(" ")[0] || ""); // Assuming no title in the data
    setSiteLocationAddress(lead.site_location_address || "");
    // setLeadTransferDate(lead.lead_transfer_date || undefined);
    setLeadOwner(lead.BDM?.EmployeeName || ""); // Lead Owner is BDM's name
    setAgentRemark(lead.agent_remark || "");
    setFollowUpDate(lead.follow_up_date || undefined);
    setClosureMonth(lead.close_month || null);
    setCallStatus(lead.call_status || "");
    setFirstName(lead.CustomerName?.split(" ")[1] || "");
    setMiddleName(lead.CustomerName?.split(" ")[2] || ""); // No middle name in the data
    setLastName(lead.CustomerName?.split(" ")[3] || "");
    setMobileNumber(lead.MobileNo || "");
    setWhatsappNumber(lead.WhatsappNo || "");
    setAlternateNumber(lead.AlternateMobileNo || "");
    setMailId(lead.CustomerMailId || "");
    setPincode(lead.pincode || "");
    setState(lead.state_name || "");
    setRegion(lead.region_name || "");
    setBranchName(lead.branchName || "");
    setBranchId(lead.branchId || "")

    setSelectedCategory({ id: lead.categoryId , name: lead.category });
    setSelectedSubCategory({ id: lead.subCategoryId, name: lead.sub_category });

    setLeadSource(lead.source_of_lead_generated || "");
    setEnquiryType(lead.InquiryType || "");
    setLocation(lead.location || "");
  };

  const today = new Date();
  const formatDate = (dateString) => dayjs(dateString).format("YYYY-MM-DD");

  const handleSubmit = (e) => {
    e.preventDefault();
    let isValid = true;

    // Reset error states before validation
    setEnquiryTypeError("");
    setLeadSourceError("");
    setAgentRemarkError("");
    setcCallStatusError("");
    setCallTypeError("");
    setFirstNameError("");
    setMiddleNameError("");
    setLastNameError("");
    setTitleError("");
    setMobileNumberError("");
    setPincodeError("");
    setStateError("");
    setRegionError("");
    setLocationError("");
    setCategoryError("");
    setSubCategoryError("");
    setWhatsappNumberError("");
    setAlternateNumberError("");
    setFollowUpDateError("");
    setClosureMonthError("");
    setProjectError("");
    setLeadOwnerError("");
    setBranchNameError("")

    // Common validation checks
    if (callStatus === "Failed" || selectedCategory.name.toLowerCase() === "pending") {
      if (enquiryType.trim() === "") {
        setEnquiryTypeError("Enquiry Type is required.");
        isValid = false;
      }

      if (callStatus.trim() === "") {
        setcCallStatusError("Call Status is required.");
        isValid = false;
      }
      if (callType.trim() === "") {
        setCallTypeError("Call Type is required.");
        isValid = false;
      }

      if (empDetails.Campaigns.length > 1) {
        if (leadSource.trim() === "") {
          setLeadSourceError("Lead Source is required.");
          isValid = false;
        }
      } else {
        setLeadSource(empDetails.Campaigns[0].CampaignId);
      }

      if (selectedCategory.name.trim() === "") {
        setCategoryError("Category is required.");
        isValid = false;
      }
      if (selectedSubCategory.name.trim() === "") {
        setSubCategoryError("Sub-Category is required.");
        isValid = false;
      }

      if (agentRemark.trim() === "") {
        setAgentRemarkError("Remark is required.");
        isValid = false;
      }
    } else {
      if (enquiryType.trim() === "") {
        setEnquiryTypeError("Enquiry Type is required.");
        isValid = false;
      }
      if (callStatus.trim() === "") {
        setcCallStatusError("Call Status is required.");
        isValid = false;
      }
      if (callType.trim() === "") {
        setCallTypeError("Call Type is required.");
        isValid = false;
      }
      if (firstName.trim() === "") {
        setFirstNameError("First Name is required.");
        isValid = false;
      }
      if (!/^[A-Za-z]*$/.test(middleName)) {
        setMiddleNameError("Only alphabetic characters are allowed.");
        isValid = false;
      }
      // if (lastName.trim() === "") {
      //   setLastNameError("Last Name is required.");
      //   isValid = false;
      // }
      if (title.trim() === "") {
        setTitleError("Title is required.");
        isValid = false;
      }
      if (mobileNumber.trim() === "") {
        setMobileNumberError("Mobile Number is required.");
        isValid = false;
      }
      if (mobileNumber.length < 10) {
        setMobileNumberError("Mobile Number should be 10 digits.");
        isValid = false;
      }
      if (pincode.trim() === "") {
        setPincodeError("Pincode is required.");
        isValid = false;
      }
      if (pincode.length < 6) {
        setPincodeError("Pincode should be 6 digits.");
        isValid = false;
      }
      if (state.trim() === "") {
        setStateError("State is required.");
        isValid = false;
      }
      if (regionNameList.length > 1) {
        if (region.trim() === "") {
          setRegionError("Region is required.");
          isValid = false;
        }
      } else {
        setRegion(regionNameList[0]?.RegionId || "");
        setRegionName(regionNameList[0]?.RegionName || "");
      }

      if (branchList.length > 1) {
        if (branchName === "") {
          setBranchNameError("Branch is required.");
          isValid = false;
        }
      } else {
        setBranchName(branchList[0]?.Branch || "");
        setBranchId(branchList[0]?.id || "");
      }

      if (location.trim() === "") {
        setLocationError("Location is required.");
        isValid = false;
      }
      if (selectedCategory.name.trim() === "") {
        setCategoryError("Category is required.");
        isValid = false;
      }
      if (selectedSubCategory.name.trim() === "") {
        setSubCategoryError("Sub-Category is required.");
        isValid = false;
      }
      if (whatsappNumber !== "" && whatsappNumber.length < 10) {
        setWhatsappNumberError("Whatsapp Number should be 10 digits.");
        isValid = false;
      }
      if (alternateNumber !== "" && alternateNumber.length < 10) {
        setAlternateNumberError("Alternate Mobile Number should be 10 digits.");
        isValid = false;
      }

      if (empDetails.Campaigns.length > 1) {
        if (leadSource.trim() === "") {
          setLeadSourceError("Lead Source is required.");
          isValid = false;
        }
      } else {
        setLeadSource(empDetails.Campaigns[0].CampaignId);
      }

      // if (projectList.length > 1) {
      //   if (project.trim() === "") {
      //     setProjectError("Project is required.");
      //     isValid = false;
      //   }
      // }

      if (leadOwner.trim() === "") {
        setLeadOwnerError("Lead Owner is required.");
        isValid = false;
      }

      // Category-specific validation
      if (selectedCategory.name.toLowerCase() === "hot" || selectedCategory.name.toLowerCase() === "warm" || selectedCategory.name.toLowerCase() === "pending") {
        if (!followUpDate || !dayjs(followUpDate).isValid()) {
          setFollowUpDateError("Follow-up date is required.");
          isValid = false;
        } else {
          setFollowUpDateError(""); // Clear error if valid
        }
      }

      if (selectedCategory.name.toLowerCase() === "hot" || selectedCategory.name.toLowerCase() === "warm") {
        if (!closureMonth) {
          setClosureMonthError("Closure Month is required.");
          isValid = false;
        }
      }

      if (agentRemark.trim() === "") {
        setAgentRemarkError("Remark is required.");
        isValid = false;
      }
    }

    

    if (isValid) {
      // Perform the form submission if valid
      const formData = {
        InquiryType: enquiryType === "" ? null : enquiryType,
        call_type: callType === "" ? callType : callType,
        Project: projectList.length === 1 ? projectList[0].label : project,
        CustomerName: `${title} ${firstName} ${middleName} ${lastName}`,
        MobileNo: mobileNumber,
        WhatsappNo: whatsappNumber === "" ? null : whatsappNumber,
        AlternateMobileNo: alternateNumber === "" ? null : alternateNumber,
        CustomerMailId: mailId === "" ? null : mailId,
        pincode: pincode === "" ? null : pincode,
        state_name: state === "" ? null : state,
        region_name:
          regionNameList.length === 1 && regionNameList[0]
            ? regionNameList[0].RegionName
            : regionName || null,
        RegionId:
          regionNameList.length === 1 && regionNameList[0]
            ? regionNameList[0].RegionId
            : region || null,
        location: location === "" ? null : location,
        siteLocationAddress:
          siteLocationAddress === "" ? null : siteLocationAddress,
         categoryId: selectedCategory.id === null ? null : selectedCategory.id,
          subCategoryId:
            selectedSubCategory.id === null ? null : selectedSubCategory.id,
        category: selectedCategory.name === "" ? null : selectedCategory.name,
        sub_category: selectedSubCategory.name === "" ? null : selectedSubCategory.name,
        bdm_remark: agentRemark === "" ? null : agentRemark,
        follow_up_date:
          followUpDate == undefined ? null : formatDate(followUpDate),
        lead_transfer_date:
          formatDate(today),
        lead_owner: leadOwner === "" ? null : leadOwner,
        // source_of_lead_generated: leadSource == "" ? null : leadSource,
        source_of_lead_generated:
          empDetails.Campaigns.length == 1
            ? empDetails.Campaigns[0].CampaignId
            : leadSource,
        close_month: closureMonth === "" ? null : closureMonth,
        AgentId: Number(localStorage.getItem("username")),
        lead_created_by: Number(localStorage.getItem("empRole")),
        call_status: callStatus === "" ? null : callStatus,
        BDMId:
          bdmID === ""
            ? [2, 3].includes(Number(localStorage.getItem("empRole")))
              ? Number(localStorage.getItem("username"))
              : null
            : Number(bdmID),
        created_by: Number(localStorage.getItem("username")),
        branchName: branchName,
        branchId: branchId
      };

      axios
        .post(CREATE_LEAD_API, formData, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        })
        .then((response) => {
          console.log(response.data);
          setSeverity("success");
          setMessage(response.data.message);
          setOpenSnackbar(true);
          if (afterLeadCreatedCallback) {
            afterLeadCreatedCallback(formData);
          }
          setOpen(false);

  //          setTimeout(() => {
  //   window.location.reload();
  // }, 1500); // 1.5 seconds delay for better UX
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.data.message);
            if (error.response.data.errors) {
              const errorData = error.response.data.errors;
              console.log(errorData);

              if (errorData.bdm_remark)
                setAgentRemarkError(errorData.bdm_remark);
              if (errorData.project) setProjectError(errorData.project);
              if (errorData.first_name) setFirstNameError(errorData.first_name);
              if (errorData.middle_name)
                setMiddleNameError(errorData.middle_name);
              // if (errorData.last_name) setLastNameError(errorData.last_name);
              if (errorData.mobile_number)
                setMobileNumberError(errorData.mobile_number);
              if (errorData.whatsapp_number)
                setWhatsappNumberError(errorData.whatsapp_number);
              if (errorData.alternate_number)
                setAlternateNumberError(errorData.alternate_number);
              if (errorData.email) setEmailError(errorData.email);
              if (errorData.pincode) setPincodeError(errorData.pincode);
              if (errorData.state) setStateError(errorData.state);
              if (errorData.region) setRegionError(errorData.region);
              if (errorData.category) setCategoryError(errorData.category);
              if (errorData.sub_category)
                setSubCategoryError(errorData.sub_category);
              if (errorData.lead_source)
                setLeadSourceError(errorData.lead_source);
              if (errorData.InquiryType)
                setEnquiryTypeError(errorData.InquiryType);
              if (errorData.call_status)
                setcCallStatusError(errorData.call_status);
              if (errorData.call_type) setCallTypeError(errorData.call_type);
              if (errorData.location) setLocationError(errorData.location);
              if (errorData.follow_up_date)
                setFollowUpDateError(errorData.follow_up_date);
              if (errorData.title) setTitleError(errorData.title);
              if (errorData.closure_month)
                setClosureMonthError(errorData.closure_month);
              if (errorData.Project) setProjectError(errorData.Project);
              if (errorData.lead_owner) setLeadOwnerError(errorData.lead_owner);
            }

            setSeverity("error");
            setMessage(error.response.data.message);
            setOpenSnackbar(true);
          } else {
            console.log(error.message);
            setSeverity("error");
            setMessage("Internal Server Error.");
            setOpenSnackbar(true);
          }
        });
    } else {
      setSeverity("error");
      setMessage("Please check for missing fields.");
      setOpenSnackbar(true);
      console.log("Form submission blocked due to validation errors.");
    }
  };

  //Reset the form Values
  const handleReset = () => {
    setEnquiryType("");
    setCallType("");
    setCallStatus("");
    setProject("");
    setFirstName("");
    setMiddleName("");
    setTitle("");
    setLastName("");
    setAlternateNumber("");
    setWhatsappNumber("");
    setMailId("");
    setPincode("");
    setState("");
    setRegion("");
    setLocation("");
    setSiteLocationAddress("");
    setSelectedCategory({ id: null, name: "" });
    setSelectedSubCategory({ id: null, name: "" }); 
    
    setAgentRemark("");
    setFollowUpDate(undefined);
    // setLeadTransferDate(undefined);
    setLeadOwner("");
    setLeadSource("");
    setClosureMonth(null);
    setCallStatus("");
    setState("");
    setProject("");

    //Validation Error
    setAgentRemarkError("");
    setProjectError("");
    setAlternateNumberError("");
    setCategoryError("");
    setSubCategoryError("");
    setFirstNameError("");
    setLastNameError("");
    setMiddleNameError("");
    setPincodeError("");
    setLeadSourceError("");
    setRegionError("");
    setEnquiryTypeError("");
    setWhatsappNumberError("");
    setEmailError("");
    setcCallStatusError("");
    setCallTypeError("");
    setLocationError("");
    setMobileNumberError("");
    setTitleError("");
    setStateError("");

    //Other
    setBdmId("");
    setIsPresent(false);
    setRegionName("");
  };

  return (
    <>
      <DialogContent>
        <Accordion defaultExpanded>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
            className={`${leadFormStyles.accordian_heading} h-auto`}
            sx={{
              "& .Mui-expanded": {
                margin: "10px 0 !important",
              },
            }}
          >
            <Typography>Contact Details</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box
              component={"form"}
              sx={{
                "& .MuiTextField-root": { m: 1, width: "25ch" },
              }}
              noValidate
              autoComplete="off"
            >
              <Grid container spacing={2}>
                <Grid item xs={12} md={6} xl={6}>
                  <TextField
                    label="Mobile Number"
                    id="outlined-size-small"
                    value={mobileNumber}
                    autoComplete="off"
                    onChange={handleMobileNumberChange}
                    size="small"
                    error={!!mobileNumberError}
                    helperText={mobileNumberError}
                    required
                    InputProps={{
                      inputProps: { maxLength: 10 },
                      endAdornment: mobileLoading && (
                        <InputAdornment position="end">
                          <CircularProgress size={20} />
                        </InputAdornment>
                      ),
                    }}
                    sx={{
                      "& .MuiFormHelperText-root": {
                        fontSize: "0.65rem",
                        marginLeft: "0",
                      },
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={6} xl={6}>
                  <TextField
                    label="Call Status"
                    select
                    id="outlined-size-small"
                    value={callStatus}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value.trim() == "") {
                        setCallStatus("");
                        setcCallStatusError("Call Status is Required");
                      } else {
                        setCallStatus(value);
                        setcCallStatusError(""); // Clear error when valid
                      }
                      handleIsMandatory(e.target.value);
                    }}
                    size="small"
                    required
                    error={!!callStatusError}
                    helperText={callStatusError}
                  >
                    {CALL_STATUS.map((ls) => (
                      <MenuItem
                        value={ls.label}
                        sx={{
                          borderBottom: "thin solid rgba(0, 0, 0, 0.12)",
                          marginBottom: "8px",
                          marginTop: "8px",
                        }}
                      >
                        {ls.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>

                <Grid item xs={12} md={6} xl={6}>
                  <TextField
                    id="outlined-select-currency"
                    select
                    label="Enquiry Type"
                    defaultValue=""
                    // helperText="Please select your currency"
                    size="small"
                    value={enquiryType}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value.trim() == "") {
                        setEnquiryType("");
                        setEnquiryTypeError("Enquiry Type is Required");
                      } else {
                        setEnquiryType(value);
                        setEnquiryTypeError(""); // Clear error when valid
                      }
                    }}
                    error={!!enquiryTypeError}
                    helperText={enquiryTypeError}
                    required
                    sx={{
                      "& .MuiFormHelperText-root": {
                        fontSize: "0.65rem",
                        marginLeft: "0",
                      },
                    }}
                  >
                    {ENQUIRY_TYPE.map((eq) => (
                      <MenuItem
                        value={eq.label}
                        sx={{
                          borderBottom: "thin solid rgba(0, 0, 0, 0.12)",
                          marginBottom: "8px",
                          marginTop: "8px",
                        }}
                      >
                        {eq.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>

                <Grid item xs={12} md={6} xl={6}>
                  <TextField
                    id="outlined-select-currency"
                    select
                    label="Call Type"
                    defaultValue=""
                    size="small"
                    // helperText="Please select your project"
                    value={callType}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value.trim() == "") {
                        setCallType("");
                        setCallTypeError("Call Type is Required");
                      } else {
                        setCallType(value);
                        setCallTypeError(""); // Clear error when valid
                      }
                    }}
                    required
                    error={!!callTypeError}
                    helperText={callTypeError}
                  >
                    {CALL_TYPE.map((p) => (
                      <MenuItem
                        value={p.label}
                        sx={{
                          borderBottom: "thin solid rgba(0, 0, 0, 0.12)",
                          marginBottom: "8px",
                          marginTop: "8px",
                        }}
                      >
                        {p.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>

                {isPresent ? (
                  <Grid
                    item
                    xs={12}
                    md={6}
                    xl={6}
                    className={`${leadFormStyles.fields_padding}`}
                  >
                    <TextField
                      label="Customer Name"
                      id="outlined-size-small"
                      value={firstName}
                      size="small"
                    />
                  </Grid>
                ) : (
                  <>
                    <Grid
                      item
                      xs={12}
                      md={6}
                      xl={6}
                      className={`${leadFormStyles.fields_padding}`}
                    >
                      <TextField
                        id="outlined-select-currency"
                        select
                        label="Title"
                        defaultValue=""
                        size="small"
                        // helperText="Please select your project"
                        value={title}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (value.trim() == "") {
                            setTitle("");
                            setTitleError("Title is Required");
                          } else {
                            setTitle(value);
                            setTitleError(""); // Clear error when valid
                          }
                        }}
                        error={!!titleError}
                        helperText={titleError}
                        required={isMandatory}
                      >
                        {TITLE.map((p) => (
                          <MenuItem
                            value={p.label}
                            sx={{
                              borderBottom: "thin solid rgba(0, 0, 0, 0.12)",
                              marginBottom: "8px",
                              marginTop: "8px",
                            }}
                          >
                            {p.label}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>

                    <Grid
                      item
                      xs={12}
                      md={6}
                      xl={6}
                      className={`${leadFormStyles.fields_padding}`}
                    >
                      <TextField
                        label="Customer First Name"
                        id="outlined-size-small"
                        value={firstName}
                        autoComplete="off"
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^[A-Za-z\s]*$/.test(value)) {
                            // Allow only alphabets and spaces
                            setFirstName(value);
                            setFirstNameError(""); // Clear error when valid
                          } else {
                            setFirstNameError(
                              "Only alphabetic characters and spaces are allowed"
                            );
                          }
                        }}
                        size="small"
                        error={!!firstNameError}
                        helperText={firstNameError}
                        required={isMandatory}
                        InputProps={{
                          inputProps: {
                            maxLength: 100,
                          },
                        }}
                        sx={{
                          "& .MuiFormHelperText-root": {
                            fontSize: "0.65rem",
                            marginLeft: "0",
                          },
                        }}
                      />
                    </Grid>

                    <Grid
                      item
                      xs={12}
                      md={6}
                      xl={6}
                      className={`${leadFormStyles.fields_padding}`}
                    >
                      <TextField
                        label="Customer Middle Name"
                        id="outlined-size-small"
                        value={middleName}
                        autoComplete="off"
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^[A-Za-z\s]*$/.test(value)) {
                            // Allow only alphabets and spaces
                            setMiddleName(value);
                            setMiddleNameError(""); // Clear error when valid
                          } else {
                            setMiddleNameError(
                              "Only alphabetic characters and spaces are allowed"
                            );
                          }
                        }}
                        size="small"
                        error={!!middleNameError}
                        helperText={middleNameError}
                        InputProps={{
                          inputProps: {
                            maxLength: 100,
                          },
                        }}
                        sx={{
                          "& .MuiFormHelperText-root": {
                            fontSize: "0.65rem",
                            marginLeft: "0",
                          },
                        }}
                      />
                    </Grid>

                    <Grid
                      item
                      xs={12}
                      md={6}
                      xl={6}
                      className={`${leadFormStyles.fields_padding}`}
                    >
                      <TextField
                        label="Customer Last Name"
                        id="outlined-size-small"
                        value={lastName}
                        autoComplete="off"
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^[A-Za-z\s]*$/.test(value)) {
                            // Allow only alphabets and spaces
                            setLastName(value);
                            setLastNameError(""); // Clear error when valid
                          } 
                          // else {
                          //   setLastNameError(
                          //     "Only alphabetic characters and spaces are allowed"
                          //   );
                          // }
                        }}
                        size="small"
                        // error={!!lastNameError}
                        // helperText={lastNameError}
                        // required={isMandatory}
                        InputProps={{
                          inputProps: {
                            maxLength: 100,
                          },
                        }}
                        sx={{
                          "& .MuiFormHelperText-root": {
                            fontSize: "0.65rem",
                            marginLeft: "0",
                          },
                        }}
                      />
                    </Grid>
                  </>
                )}

                <Grid
                  item
                  xs={12}
                  md={6}
                  xl={6}
                  className={`${leadFormStyles.fields_padding}`}
                >
                  <TextField
                    label="Whatsapp Number"
                    id="outlined-size-small"
                    autoComplete="off"
                    value={whatsappNumber}
                    onChange={(e) => {
                      const value = e.target.value;
                      // Validate for numeric characters only and length
                      if (/^\d{0,10}$/.test(value)) {
                        setWhatsappNumber(value);
                        setWhatsappNumberError("");
                      } else {
                        setWhatsappNumberError(
                          "Whatsapp Number should be 10 digits"
                        );
                      }
                    }}
                    size="small"
                    error={!!whatsappNumberError}
                    helperText={whatsappNumberError}
                    InputProps={{
                      inputProps: {
                        maxLength: 10,
                      },
                    }}
                    sx={{
                      "& .MuiFormHelperText-root": {
                        fontSize: "0.65rem",
                        marginLeft: "0",
                      },
                    }}
                  />
                </Grid>

                <Grid
                  item
                  xs={12}
                  md={6}
                  xl={6}
                  className={`${leadFormStyles.fields_padding}`}
                >
                  <TextField
                    label="Alternate Number"
                    id="outlined-size-small"
                    autoComplete="off"
                    value={alternateNumber}
                    onChange={(e) => {
                      const value = e.target.value;
                      // Validate for numeric characters only and length
                      if (/^\d{0,10}$/.test(value)) {
                        setAlternateNumber(value);
                        setAlternateNumberError("");
                      } else {
                        setAlternateNumberError(
                          "Alternate Number should be 10 digits"
                        );
                      }
                    }}
                    size="small"
                    error={!!alternateNumberError}
                    helperText={alternateNumberError}
                    InputProps={{
                      inputProps: {
                        maxLength: 10,
                      },
                    }}
                    sx={{
                      "& .MuiFormHelperText-root": {
                        fontSize: "0.65rem",
                        marginLeft: "0",
                      },
                    }}
                  />
                </Grid>

                <Grid
                  item
                  xs={12}
                  md={6}
                  xl={6}
                  className={`${leadFormStyles.fields_padding}`}
                >
                  <TextField
                    label="Customer Mail ID"
                    id="outlined-size-small"
                    value={mailId}
                    autoComplete="off"
                    onChange={(e) => {
                      const value = e.target.value;
                      // Validate for email format
                      if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
                        setMailId(value);
                        setEmailError("");
                      } else {
                        setMailId(value);
                        setEmailError("Invalid email format.");
                      }
                    }}
                    size="small"
                    error={!!emailError}
                    helperText={emailError}
                    sx={{
                      "& .MuiFormHelperText-root": {
                        fontSize: "0.65rem",
                        marginLeft: "0",
                      },
                    }}
                  />
                </Grid>

                <Grid
                  item
                  xs={12}
                  md={6}
                  xl={6}
                  className={`${leadFormStyles.fields_padding}`}
                >
                  <TextField
                    label="Postal Pincode"
                    id="outlined-size-small"
                    value={pincode}
                    onChange={(e) => {
                      const value = e.target.value.trim();

                      // Check if the field is empty
                      if (value === "") {
                        setPincode(value);
                        setPincodeError("Pincode is required");
                        return;
                      }
                      setState("");
                      setRegion("");
                      setLocation("");
                      setRegionNameList([]);
                      // Validate numeric input
                      if (/^\d{0,6}$/.test(value)) {
                        setPincode(value);
                        setPincodeError("");

                        // Call API only when the pincode length is valid
                        if (value.length === 6) {
                          fetchStateAndRegionByPincode(value);
                        }
                      } else {
                        setPincode(value);
                        setPincodeError("Invalid pincode format");
                      }
                    }}
                    size="small"
                    required={isMandatory}
                    autoComplete="off"
                    error={!!pincodeError}
                    helperText={pincodeError}
                    InputProps={{
                      inputProps: {
                        maxLength: 6, // Pincode should be 6 digits max
                        inputMode: "numeric", // Optimized for mobile numeric input
                      },
                      endAdornment: pincodeLoading ? (
                        <InputAdornment position="end">
                          <CircularProgress size={20} />
                        </InputAdornment>
                      ) : null,
                    }}
                    sx={{
                      "& .MuiFormHelperText-root": {
                        fontSize: "0.65rem",
                        marginLeft: "0",
                      },
                    }}
                  />
                </Grid>

                <Grid
                  item
                  xs={12}
                  md={6}
                  xl={6}
                  className={`${leadFormStyles.fields_padding}`}
                >
                  <TextField
                    id="outlined-select-currency"
                    label="State"
                    value={state}
                    // onChange={handleStateChange}
                    // helperText="Please select your currency"
                    size="small"
                    required={isMandatory}
                    error={!!stateError}
                    helperText={stateError}
                    InputProps={{
                      inputProps: {
                        pattern: "^[A-Za-z]*$",
                        title: "Only alphabetic characters are allowed",
                        readOnly: true,
                      },
                    }}
                    sx={{
                      "& .MuiFormHelperText-root": {
                        fontSize: "0.65rem",
                        marginLeft: "0",
                      },
                    }}
                  />
                </Grid>

                <Grid
                  item
                  xs={12}
                  md={6}
                  xl={6}
                  className={`${leadFormStyles.fields_padding}`}
                >
                  {isPresent ||
                  (regionNameList.length === 1 &&
                    regionNameList[0].RegionName) ? (
                    <TextField
                      id="outlined-select-currency"
                      label="Region"
                      value={isPresent ? region : regionNameList[0].RegionName}
                      size="small"
                      InputProps={{
                        readOnly: true, // Make the field read-only
                      }}
                      sx={{
                        "& .MuiInputBase-input": {
                          color: "rgba(0, 0, 0, 0.87)",
                        },
                      }}
                    />
                  ) : (
                    <TextField
                      id="outlined-select-currency"
                      select
                      label="Region"
                      value={region}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value.trim() === "") {
                          setRegion("");
                          setRegionError("Region is required.");
                        } else {
                          setRegion(value);
                          setRegionError("");

                          // Find the region name based on the selected ID
                          const selectedRegion = regionNameList.find(
                            (cl) => cl.RegionId === value
                          );
                          const regionName = selectedRegion?.RegionName || ""; // Default to empty string if not found
                          setRegionName(regionName);
                          fetchLeadOwnerfromRegion(value);
                        }
                      }}
                      size="small"
                      required={isMandatory}
                      error={!!regionError}
                      helperText={regionError}
                      sx={{
                        "& .MuiFormHelperText-root": {
                          fontSize: "0.65rem",
                          marginLeft: "0",
                        },
                      }}
                    >
                      {regionNameList.map((cl) => (
                        <MenuItem key={cl.RegionId} value={cl.RegionId}>
                          {cl.RegionName}
                        </MenuItem>
                      ))}
                    </TextField>
                  )}
                </Grid>

                {isOtherLocation && (
                  <Grid
                    item
                    xs={12}
                    md={6}
                    xl={6}
                    className={`${leadFormStyles.fields_padding}`}
                  >
                    {isPresent ? (
                      <TextField
                        id="outlined-select-currency"
                        label="Location"
                        value={location}
                        //  onChange={handleStateChange}
                        size="small"
                      />
                    ) : (
                      <TextField
                        label="Location"
                        select
                        id="outlined-size-small"
                        value={location}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (value.trim() === "") {
                            setLocation(value);
                            setLocationError("Location is required.");
                          } else {
                            setLocation(value);
                            setIsOtherLocation(
                              value === "Other" ? false : true
                            );
                            setLocationError("");
                          }
                        }}
                        size="small"
                        required={isMandatory}
                        error={!!locationError}
                        helperText={locationError}
                        sx={{
                          "& .MuiFormHelperText-root": {
                            fontSize: "0.65rem",
                            marginLeft: "0",
                          },
                        }}
                      >
                        {locationList &&
                          locationList.map((pl) => (
                            <MenuItem value={pl.names}>{pl.names}</MenuItem>
                          ))}
                        <MenuItem value={"other"}>Other</MenuItem>
                      </TextField>
                    )}
                  </Grid>
                )}

                {location === "other" && (
                  <Grid
                    item
                    xs={12}
                    md={6}
                    xl={6}
                    className={`${leadFormStyles.fields_padding}`}
                  >
                    <TextField
                      label="Location"
                      id="outlined-size-small"
                      autoComplete="off"
                      // value={location}
                      onChange={(e) => setLocation(e.target.value)}
                      size="small"
                    />
                  </Grid>
                )}

                <Grid
                  item
                  xs={12}
                  md={6}
                  xl={6}
                  className={`${leadFormStyles.fields_padding}`}
                >
                  {isPresent ||
                  (branchList.length === 1 &&
                    branchList[0].Branch) ? (
                    <TextField
                      id="outlined-select-currency"
                      label="Branch"
                      value={isPresent ? branchName : branchList[0].Branch}
                      size="small"
                      InputProps={{
                        readOnly: true, // Make the field read-only
                      }}
                      sx={{
                        "& .MuiInputBase-input": {
                          color: "rgba(0, 0, 0, 0.87)",
                        },
                      }}
                    />
                  ) : (
                    <TextField
                      id="outlined-select-currency"
                      select
                      label="Branch"
                      value={branchId}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value === "") {
                          setBranchName("");
                          setBranchNameError("Branch Name is required.");
                        } else {
                          setBranchId(value);
                          setBranchNameError("");

                          // Find the region name based on the selected ID
                          const selectedRegion = branchList.find(
                            (cl) => cl.id === value
                          );
                          const regionName = selectedRegion?.Branch || ""; // Default to empty string if not found
                          setBranchName(regionName);
                        }
                      }}
                      size="small"
                      required={isMandatory}
                      error={!!branchNameError}
                      helperText={branchNameError}
                      sx={{
                        "& .MuiFormHelperText-root": {
                          fontSize: "0.65rem",
                          marginLeft: "0",
                        },
                      }}
                    >
                      {branchList.map((cl) => (
                        <MenuItem key={cl.id} value={cl.id}>
                          {cl.Branch}
                        </MenuItem>
                      ))}
                    </TextField>
                  )}
                </Grid>

                <Grid
                  item
                  xs={12}
                  md={6}
                  xl={6}
                  className={`${leadFormStyles.fields_padding}`}
                >
                  {empDetails.Campaigns.length === 1 ? (
                    <TextField
                      label="Lead Source"
                      id="outlined-size-small"
                      value={empDetails.Campaigns[0].CampaignName}
                      size="small"
                      required
                      InputProps={{
                        readOnly: true, // Make it read-only
                      }}
                      sx={{
                        "& .MuiInputBase-input": {
                          color: "rgba(0, 0, 0, 0.87)", // Optional styling for read-only text
                        },
                        "& .MuiFormHelperText-root": {
                          fontSize: "0.65rem",
                          marginLeft: "0",
                        },
                      }}
                    />
                  ) : (
                    <TextField
                      label="Lead Source"
                      select
                      id="outlined-size-small"
                      value={leadSource}
                      onChange={(e) => {
                        const value = e.target.value;

                        if (value === "") {
                          setLeadSourceError("Lead source is required.");
                        } else {
                          setLeadSource(value);
                          setLeadSourceError(""); // Clear the error if valid
                        }
                      }}
                      size="small"
                      required
                      error={!!leadSourceError}
                      helperText={leadSourceError}
                      sx={{
                        "& .MuiFormHelperText-root": {
                          fontSize: "0.65rem",
                          marginLeft: "0",
                        },
                      }}
                    >
                      {empDetails.Campaigns.map((p) => (
                        <MenuItem
                          key={p.CampaignId} // Ensure unique keys
                          value={p.CampaignId}
                          sx={{
                            borderBottom: "thin solid rgba(0, 0, 0, 0.12)",
                            marginBottom: "8px",
                            marginTop: "8px",
                          }}
                        >
                          {p.CampaignName}
                        </MenuItem>
                      ))}
                    </TextField>
                  )}
                </Grid>

                <Grid
                  item
                  xs={12}
                  md={6}
                  xl={6}
                  className={`${leadFormStyles.fields_padding}`}
                >
                  <TextField
                    label="Lead Owner"
                    id="outlined-size-small"
                    select={bdmList.length > 1}
                    value={leadOwner}
                    onChange={(e) => {
                      const selectedEmployeeId = e.target.value;
                      setLeadOwner(selectedEmployeeId);
                      setBdmId(selectedEmployeeId);
                      handleProjectChange(selectedEmployeeId);
                      setLeadOwnerError("");
                    }}
                    size="small"
                    InputProps={{
                      readOnly: bdmList.length === 1,
                    }}
                    required={isMandatory}
                    error={!!leadOwnerError}
                    helperText={leadOwnerError}
                  >
                    {bdmList.length === 1 ? (
                      <MenuItem
                        key={bdmList[0].EmployeeId}
                        value={bdmList[0].EmployeeId}
                      >
                        {bdmList[0].EmployeeName}
                      </MenuItem>
                    ) : (
                      bdmList.map((p) => (
                        <MenuItem
                          key={p.EmployeeId}
                          value={p.EmployeeId}
                          sx={{
                            borderBottom: "thin solid rgba(0, 0, 0, 0.12)",
                            marginBottom: "8px",
                            marginTop: "8px",
                          }}
                        >
                          {p.EmployeeName}
                        </MenuItem>
                      ))
                    )}
                  </TextField>
                </Grid>

                <Grid
                  item
                  xs={12}
                  md={6}
                  xl={6}
                  className={`${leadFormStyles.fields_padding}`}
                >
                  {/* Check if there's only one project and set it directly */}
                  {projectList.length === 1 ? (
                    <TextField
                      id="outlined-select-currency"
                      label="Project"
                      value={projectList[0].label} // Automatically set to the only project
                      size="small"
                      InputProps={{
                        readOnly: true, // Make the field read-only when only one project exists
                      }}
                      sx={{
                        "& .MuiInputBase-input": {
                          color: "rgba(0, 0, 0, 0.87)",
                        },
                      }}
                    />
                  ) : (
                    <TextField
                      id="outlined-select-currency"
                      select
                      label="Project"
                      required={isMandatory}
                      error={!!projectError}
                      helperText={projectError}
                      size="small"
                      value={project}
                      onChange={(e) => {
                        setProject(e.target.value);
                        setProjectError("");
                      }}
                    >
                      {projectList.map((p) => (
                        <MenuItem
                          key={p.label}
                          value={p.label}
                          sx={{
                            borderBottom: "thin solid rgba(0, 0, 0, 0.12)",
                            marginBottom: "8px",
                            marginTop: "8px",
                          }}
                        >
                          {p.label}
                        </MenuItem>
                      ))}
                    </TextField>
                  )}
                </Grid>

                <Grid
                  item
                  xs={12}
                  md={6}
                  xl={6}
                  className={`${leadFormStyles.fields_padding}`}
                >
                  <TextField
                    label="Site Location Address"
                    id="outlined-size-small"
                    multiline
                    rows={4}
                    autoComplete="off"
                    value={siteLocationAddress}
                    onChange={(e) => setSiteLocationAddress(e.target.value)}
                    size="small"
                    InputProps={{
                      inputProps: {
                        maxLength: 100,
                      },
                    }}
                  />
                </Grid>
              </Grid>
            </Box>
          </AccordionDetails>
        </Accordion>

        <Accordion defaultExpanded>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
            className={`${leadFormStyles.accordian_heading} h-auto`}
            sx={{
              "& .Mui-expanded": {
                margin: "10px 0 !important",
              },
            }}
          >
            <Typography>Disposition Summary</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box
              component="form"
              sx={{
                "& .MuiTextField-root": { m: 1, width: "25ch" },
              }}
              noValidate
              autoComplete="off"
            >
              <Grid container spacing={2}>
                <Grid item xs={12} md={6} xl={6}>
                  <TextField
                                  select
                                  label="Category"
                                  value={selectedCategory.name}
                                  fullWidth
                                  onChange={(e) => {
                                    const selected = categoryList.find(
                                      (cat) => cat.CategoryName === e.target.value
                                    );
                                    if (selected) {
                                      setSelectedCategory({
                                        id: selected.CategoryId,
                                        name: selected.CategoryName,
                                      });
                                      setSelectedSubCategory({ id: null, name: "" }); // reset subcategory
                                      setCategoryError("");
                                    } else {
                                      setCategoryError("Category is required.");
                                    }
                  
                                    handleIsMandatory(selected.CategoryName.toLowerCase());
                                  }}
                                  size="small"
                                  required
                                  error={!!categoryError}
                                  helperText={categoryError}
                                >
                                  {categoryList.map((cat) => (
                                    <MenuItem key={cat.CategoryId} value={cat.CategoryName}>
                                      {cat.CategoryName}
                                    </MenuItem>
                                  ))}
                                </TextField>
                </Grid>

                <Grid item xs={12} md={6} xl={6}>
                  <TextField
                    select
                    label="Sub-Category"
                    value={selectedSubCategory.name || ""}
                    fullWidth
                    onChange={(e) => {
                      const subcats =
                        categoryList.find(
                          (cat) => cat.CategoryId === selectedCategory.id
                        )?.subcategories || [];
                  
                      const selectedSub = subcats.find(
                        (sub) => sub.SubCategoryName === e.target.value
                      );
                  
                      if (selectedSub) {
                        setSelectedSubCategory({
                          id: selectedSub.SubCategoryId,
                          name: selectedSub.SubCategoryName,
                        });
                        setSubCategoryError("");
                      } else {
                        setSubCategoryError("Sub-Category is required.");
                      }
                    }}
                    size="small"
                    required
                    error={!!subCategoryError}
                    helperText={subCategoryError}
                  >
                    {categoryList
                      .find((cat) => cat.CategoryName.toLowerCase() === selectedCategory.name.toLowerCase())
                      ?.subcategories.map((sub) => (
                        <MenuItem
                          key={sub.SubCategoryId}
                          value={sub.SubCategoryName}
                        >
                          {sub.SubCategoryName}
                        </MenuItem>
                      ))}
                  </TextField>
                </Grid>

                {/* {(selectedCategory.name.toLowerCase() === "hot" ||
                  selectedCategory.name.toLowerCase() === "warm") && (
                  <Grid
                    item
                    xs={12}
                    md={6}
                    xl={6}
                    className={`${leadFormStyles.fields_padding}`}
                  >
                    {isPresent ? (
                      <DatePicker
                        label="Lead Transfer Date"
                        value={dayjs(leadTransferDate)}
                        slotProps={{
                          textField: {
                            readOnly: true,
                          },
                        }}
                      />
                    ) : (
                      <DatePicker
                        label="Lead Transfer Date"
                        onChange={(e) => {
                          {
                            const date = new Date(e.$d);
                            const year = date.getFullYear();
                            const month = ("0" + (date.getMonth() + 1)).slice(
                              -2
                            ); // Months are zero indexed, so we add 1
                            const day = ("0" + date.getDate()).slice(-2);
                            const formattedDate = `${year}-${month}-${day}`;
                            setLeadTransferDate(formattedDate);
                          }
                        }}
                        disablePast
                        slotProps={{
                          textField: {
                            readOnly: true,
                          },
                        }}
                      />
                    )}
                  </Grid>
                )} */}

                {(selectedCategory.name.toLowerCase() === "hot" ||
                  selectedCategory.name.toLowerCase() === "warm" ||
                  selectedCategory.name.toLowerCase() === "pending") && (
                  <Grid
                    item
                    xs={12}
                    md={6}
                    xl={6}
                    className={`${leadFormStyles.fields_padding}`}
                  >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      {isPresent ? (
                        <DateTimePicker
                          label="Follow-up Date"
                          name="startDateTime"
                          value={dayjs(followUpDate)}
                          disablePast
                          slotProps={{
                            textField: {
                              readOnly: true,
                            },
                          }}
                        />
                      ) : (
                        <DateTimePicker
                          label="Follow-up Date"
                          name="startDateTime"
                          onChange={(value) => {
                            if (!value || !dayjs(value).isValid()) {
                              setFollowUpDateError(
                                "Follow-up date is required."
                              );
                            } else {
                              setFollowUpDate(
                                dayjs(value).format("YYYY-MM-DDTHH:mm:ss")
                              );
                              setFollowUpDateError("");
                            }
                          }}
                          slotProps={{
                            textField: {
                              error: !!followUpDateError,
                              helperText: followUpDateError,
                              required: true,
                              readOnly: true,
                            },
                          }}
                          disablePast
                          renderInput={(params) => <TextField {...params} />}
                        />
                      )}
                    </LocalizationProvider>
                  </Grid>
                )}

                {(selectedCategory.name.toLowerCase() === "hot" ||
                  selectedCategory.name.toLowerCase() === "warm") && (
                  <Grid
                    item
                    xs={12}
                    md={6}
                    xl={6}
                    className={`${leadFormStyles.fields_padding}`}
                  >
                    {isPresent ? (
                      <DatePicker
                        label={"Expected Closure Month"}
                        views={["month", "year"]}
                        value={dayjs(closureMonth)}
                        onChange={(newValue) => {
                          setClosureMonth(newValue); // Store as dayjs
                        }}
                        disableFuture // Optional: Disable future dates
                        slotProps={{
                          textField: {
                            readOnly: true,
                          },
                        }}
                      />
                    ) : (
                      <DatePicker
                        label={"Closure Month"}
                        views={["month", "year"]}
                        onChange={(newValue) => {
                          // newValue is the selected date object
                          const formattedValue =
                            dayjs(newValue).format("YYYY-MMM");
                          setClosureMonth(formattedValue); // Set the formatted value to state

                          // Validation check
                          if (!newValue) {
                            setClosureMonthError("Closure Month is required.");
                          } else {
                            setClosureMonthError(""); // Clear the error if the date is valid
                          }
                        }}
                        slotProps={{
                          textField: {
                            error: !!closureMonthError,
                            helperText: closureMonthError, // Display the error message
                            required: isMandatory ? true : false,
                            readOnly: true,
                          },
                        }}
                        disablePast
                      />
                    )}
                  </Grid>
                )}

                <Grid
                  item
                  xs={12}
                  md={6}
                  xl={6}
                  className={`${leadFormStyles.fields_padding}`}
                >
                  <TextField
                    id="outlined-multiline-static"
                    label="Remarks"
                    multiline
                    rows={4}
                    fullWidth
                    value={agentRemark}
                    inputProps={{
                      maxLength: 250,
                    }}
                    style={{ resize: "both", overflow: "auto" }}
                    onChange={(e) => {
                      const newRemark = e.target.value.slice(0, 250); // Trim to 250 characters
                      setAgentRemark(newRemark);

                      // Remove the error message when the user starts typing
                      if (newRemark.length > 0 && agentRemarkError) {
                        setAgentRemarkError("");
                      }
                    }}
                    required
                    error={!!agentRemarkError}
                    helperText={agentRemarkError}
                    sx={{
                      "& .MuiFormHelperText-root": {
                        fontSize: "0.65rem",
                        marginLeft: "0",
                      },
                    }}
                  />
                  <Typography
                    variant="body2"
                    color={
                      agentRemark.length > 250 ? "error" : "text.secondary"
                    }
                    sx={{ marginLeft: "7px" }}
                  >
                    {agentRemark.length}/250
                  </Typography>
                </Grid>
              </Grid>
            </Box>
          </AccordionDetails>
        </Accordion>
      </DialogContent>
      {!isPresent && (
        <DialogActions>
          <Button onClick={handleReset}>Reset</Button>
          <Button type="submit" onClick={handleSubmit}>
            Save
          </Button>
        </DialogActions>
      )}
    </>
  );
}

export default AddLeadForm;
